import { k as ensure_array_like, b as attr, c as attr_class, e as escape_html, p as pop, a as push, m as stringify } from "./index2.js";
function Pagination($$payload, $$props) {
  push();
  const { currentPage, totalPages, onPageChange } = $$props;
  function generatePaginationItems() {
    const items = [];
    const maxVisiblePages = 7;
    if (totalPages <= maxVisiblePages + 2) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(i);
      }
    } else {
      items.push(1);
      const startPage = Math.max(2, currentPage - 2);
      const endPage = Math.min(totalPages - 1, currentPage + 2);
      if (startPage > 2) {
        items.push("ellipsis");
      }
      for (let i = startPage; i <= endPage; i++) {
        items.push(i);
      }
      if (endPage < totalPages - 1) {
        items.push("ellipsis");
      }
      if (totalPages > 1) {
        items.push(totalPages);
      }
    }
    return items;
  }
  const paginationItems = generatePaginationItems();
  const canGoPrevious = currentPage > 1;
  const canGoNext = currentPage < totalPages;
  if (totalPages > 1) {
    $$payload.out.push("<!--[-->");
    const each_array = ensure_array_like(paginationItems);
    $$payload.out.push(`<nav class="flex items-center justify-center" aria-label="Pagination Navigation"><div class="flex flex-wrap items-center justify-center gap-1 sm:gap-2"><button class="rounded-md bg-gray-100 px-3 py-2 text-sm transition-colors hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50 sm:px-4"${attr("disabled", !canGoPrevious, true)} aria-label="Go to previous page"><span class="hidden sm:inline">Previous</span> <span class="sm:hidden">Prev</span></button> <!--[-->`);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let item = each_array[$$index];
      if (item === "ellipsis") {
        $$payload.out.push("<!--[-->");
        $$payload.out.push(`<span class="flex items-center px-2 text-sm text-gray-500" aria-hidden="true">...</span>`);
      } else {
        $$payload.out.push("<!--[!-->");
        $$payload.out.push(`<button${attr_class(`rounded-md px-3 py-2 text-sm transition-colors hover:bg-gray-200 sm:px-4 ${stringify(currentPage === item ? "bg-primary hover:bg-primary/90 text-white" : "bg-gray-100")}`)}${attr("aria-label", `Go to page ${stringify(item)}`)}${attr("aria-current", currentPage === item ? "page" : void 0)}>${escape_html(item)}</button>`);
      }
      $$payload.out.push(`<!--]-->`);
    }
    $$payload.out.push(`<!--]--> <button class="rounded-md bg-gray-100 px-3 py-2 text-sm transition-colors hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50 sm:px-4"${attr("disabled", !canGoNext, true)} aria-label="Go to next page"><span class="hidden sm:inline">Next</span> <span class="sm:hidden">Next</span></button></div></nav>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]-->`);
  pop();
}
export {
  Pagination as P
};
